import React, { useContext } from "react";
import { ServicesContext } from "../../context/ServicesDataProvider";
import spareSalesImg from "../../assets/images/spareSalesDetails.svg";
import { Link } from "react-router-dom";
import WaterMark from "../WaterMark";

const SpareSales = () => {
  const { sparesSalesData } = useContext(ServicesContext);

  const otcData = {
    otcSales: sparesSalesData?.otcSales?.doc_count,
    orderValueOtc: sparesSalesData?.orderValueOtc?.Invoice_Amount?.value,
    uniquePartsOtc: sparesSalesData?.uniquePartsOtc?.Unique_no_of_parts?.value,
  };

  const serviceData = {
    orederService: sparesSalesData?.orederService?.doc_count,
    orderValueService: sparesSalesData?.orderValueService?.Invoice_Amount?.value,
    uniquePartsService: sparesSalesData?.uniquePartsService?.Unique_no_of_parts_service?.value,
  };

  // Helper: format value in Lac or Cr approx
  const formatValue = (num) => {
    if (!num && num !== 0) return "0";
    if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(1)} Cr`;
    if (num >= 100000) return `₹ ${(num / 100000).toFixed(1)} L`;
    return `₹ ${num.toLocaleString("en-IN")}`;
  };

  return (
    <div className="w-full max-w-4xl max-h-64 h-full rounded-lg">
      <div className="bg-[#2374BF] rounded-t-lg flex w-full">
        <p className="text-white text-md pl-2 p-1 w-full font-semibold">Spare Sales</p>
        <Link to={"/spare-sales"} className="flex gap-2 items-center justify-end w-full">
          <p className="text-sm text-white">Spare Sales details</p>
          <img src={spareSalesImg} alt="spare sales details" />
        </Link>
      </div>

      <div className="grid grid-cols-3 gap-4 p-2 mt-3">
        {/* No. of Orders */}
        <div className="border rounded-lg p-4 shadow-md bg-gray-50">
          <h2 className="text-md text-gray-700 font-semibold text-center">No. of Orders</h2>
          <div className="flex flex-col text-sm items-center mt-1">
            <p className="text-center">Service Order</p>
            <div className="bg-[#7ED3FF] text-sm text-white px-3 text-center py-1 rounded-lg text-center">
              {serviceData?.orederService}
            </div>
          </div>
          <div className="flex flex-col text-sm items-center mt-1">
            <p className="text-center">OTC Sales</p>
            <div className="bg-[#8DFFCB] text-white text-sm px-3 py-1 rounded-lg">
              {otcData?.otcSales}
            </div>
          </div>
        </div>

        {/* Order Value in Lac/Cr */}
        <div className="border rounded-lg p-4 shadow-md bg-gray-50">
          <h2 className="text-md font-semibold text-gray-700 text-center">Order Value</h2>
          <div className="flex flex-col justify-center items-center text-sm mt-2">
            <p className="text-center">Service Order</p>
            <div className="bg-[#7ED3FF] text-white text-sm px-3 py-1 rounded-lg text-center">
              {formatValue(serviceData?.orderValueService)}
            </div>
          </div>
          <div className="flex flex-col text-sm items-center mt-1">
            <p className="text-center">OTC Sales</p>
            <div className="bg-[#8DFFCB] text-white px-3 py-1 rounded-lg text-center">
              {formatValue(otcData?.orderValueOtc)}
            </div>
          </div>
        </div>

        {/* Unique Part No. */}
        <div className="border rounded-lg p-4 shadow-md bg-gray-50">
          <h2 className="text-md font-semibold text-center text-gray-700">Unique Part No.</h2>
          <div className="flex flex-col text-sm items-center mt-2">
            <p className="text-center">Service Order</p>
            <div className="bg-[#7ED3FF] text-white text-sm px-3 py-1 rounded-lg text-center">
              {serviceData?.uniquePartsService}
            </div>
          </div>
          <div className="flex flex-col items-center text-sm mt-2">
            <p className="text-center">OTC Sales</p>
            <div className="bg-[#8DFFCB] text-white px-3 text-sm py-1 rounded-lg">
              {otcData?.uniquePartsOtc}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpareSales;
